import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { SuporteAiDados } from "@app/Domain/Models/suporte-ai-dados.model";
import { environment } from "environments/environments";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class SuporteAiService {
    private readonly url = environment.BaseUrl + "suporte-ai/contexto";
    private http = inject(HttpClient);

    getContexto(): Observable<SuporteAiDados> {
        return this.http.get<SuporteAiDados>(this.url);
    }
}
